
(function() {

    'use strict';
    angular.module('app')
        .service('accountsService',
            [
                '$http', function($http) {
                    this.getAccounts = function(filter, start, count) {
                        return $http.get('api/account/getaccounts',
                            { params: { filter: filter, start: start, count: count } })
                            .then(function(response) {
                                    return response.data;
                                },
                                function() {
                                    throw ('Accounts Retrieval Failure');
                                });
                    };
                    this.unlockAccount = function(accountId) {
                        return $http.post('api/account/unlock/' + accountId,{ })
                            .then(function (response) {
                                    return response.data;
                                },
                                function (response) {
                                    throw (response.data);
                                });
                    };

                    this.getAccount = function(accountId) {
                        return $http.get('api/account/get?accountId=' + accountId)
                            .then(function(response) {
                                    return response.data;
                                },
                                function() {
                                    throw ('Account Retrieval Failure');
                                });
                    };

                    this.getPendingRequests = function(accountId) {
                        return $http.get('api/account/getPendingRequests?accountId=' + accountId)
                            .then(function(response) {
                                    return response.data;
                                },
                                function() {
                                    throw ('Pending Request Retrieval Failure');
                                });
                    };


                    this.createAccount = function(account, clientToken, recaptcha) {
                        return $http.post('api/account/create',
                            {
                                account: account,
                                clientToken: clientToken,
                                password: account.password,
                                recaptcha:
                                    recaptcha
                            })
                            .then(function(response) {
                                    return response.data;
                                },
                                function(response) {
                                    throw (response.data);
                                });
                    };

                    this.addEnvironment = function (accountId, enviroment, isAdmin) {
                        return $http.post('api/account/addEnviroment',
                            {
                                account: accountId,
                                enviroment: enviroment,
                                isAdmin: isAdmin
                            })
                            .then(function (response) {
                                return response.data;
                            },
                                function (response) {
                                    throw (response.data);
                                });
                    }

                    this.AddIpAddress = function(ipAddress, accountId) {
                        return $http.post('api/account/AuthenticateIp', { AccountId: accountId, IpAddress: ipAddress })
                            .then(function(response) {
                                    return;
                                },
                                function(response) {
                                    throw (response.data);
                                });


                    }

                    this.updateAccount = function(account) {
                        return $http.post('api/account/update', { account: account })
                            .then(function() {
                                    return;
                                },
                                function(response) {
                                    throw (response.data);
                                });
                    };

                    this.deleteAccount = function(accountId) {
                        return $http.post('api/account/delete', { accountId: accountId })
                            .then(function() {
                                    return;
                                },
                                function() {
                                    throw ('Account Deletion Failure');
                                });
                    };


                    this.getAuthorizedAccount = function() {
                        return $http.get('api/account/getAuthorizedAccount')
                            .then(function(response) {


                                    return response.data;
                                },
                                function() {
                                    throw ('Authorized Account Retrieval Failure');
                                });
                    };
                    this
                        .verifyGoogleAuthenticator =
                        function (code, secretKey, securityQuestionId, securityQuestionAnswer, accountId) {

                            return $http.post('api/account/verifyGoogleAuthenticator',
                                {
                                    code: code,
                                    SecretKey: secretKey,
                                    SecurityQuestionId: securityQuestionId.toString(),
                                    SecurityQuestionAnswer: securityQuestionAnswer,
                                    AccountId: accountId
                                })
                                .then(function(response) {
                                        return response.data;
                                    },
                                    function() {
                                        throw ('Verifying two-factor authenticator failure');
                                    });
                        };
                    this.getSecurityQuestions = function(includeDisabledQuestions) {
                        return $http.get('api/account/getSecurityQuestions?includeDisabledQuestions=' +
                                includeDisabledQuestions)
                            .then(function(response) {
                                    return response.data;
                                },
                                function() {
                                    throw ('getSecurityQuestions Retrieval Failure');
                                });
                    }
                    this.getGoogleAuthenticatorBarcode = function(accountId) {
                        return $http.get('api/account/getGoogleAuthenticatorBarcode?accountId=' + accountId)
                            .then(function(response) {
                                    return response.data;
                                },
                                function() {
                                    throw ('getGoogleAuthenticatorBarcode Retrieval Failure');
                                });
                    }

                    this.getAuthenticatedAccount = function() {
                        return $http.get('api/account/getAuthenticated')
                            .then(function(response) {
                                    return response.data;
                                },
                                function() {
                                    throw ('Active Account Retrieval Failure');
                                });
                    };

                    this.activate = function(token) {
                        return $http.post('api/account/activate', { token: token })
                            .then(function() {
                                    return;
                                },
                                function() {
                                    throw ('Activation Failure');
                                });
                    };

                    this.deactivate = function (accountId) {
                        return $http.get('api/account/deactivate/' + accountId)
                            .then(function() {
                                    return;
                                },
                                function() {
                                    throw ('Activation Failure');
                                });
                    };
                    this.reactivate = function (accountId) {
                        return $http.get('api/account/reactivate/' + accountId)
                            .then(function() {
                                    return;
                                },
                                function() {
                                    throw ('Activation Failure');
                                });
                    };

                    this.sendActivationEmail = function(accountId) {
                        return $http.get('api/account/sendactivationemail/' + accountId)
                            .then(function() {
                                    return;
                                },
                                function() {
                                    throw ('Send Activation Email Failure');
                                });
                    };

                    this.authenticateIpAddress = function(token) {
                        return $http.post('api/account/authenticateIpAddress', { token: token })
                            .then(function() {
                                    return;
                                },
                                function() {
                                    throw ('IP Authentication Failure');
                                });
                    };

                    this.resetPassword = function(token, password) {
                        return $http.post('api/account/resetPassword', { token: token, password: password })
                            .then(function() {
                                    return;
                                },
                                function(response) {
                                    throw (response.data);
                                });
                    };
                    this.adminResetPassword = function(accountId, password) {
                        return $http.post('api/account/adminResetPassword', { token: accountId, password: password })
                            .then(function() {
                                    return;
                                },
                                function(response) {
                                    throw (response.data);
                                });
                    };
                    this.resetAuthenticator = function(token, password) {
                        return $http.post('api/account/resetAuthenticator', { token: token })
                            .then(function() {
                                    return;
                                },
                                function(response) {
                                    throw (response.data);
                                });
                    };

                    this.changePassword = function(currentPassword, newPassword) {
                        return $http.post('api/account/changePassword',
                            { currentPassword: currentPassword, newPassword: newPassword })
                            .then(function(response) {
                                    return response.data;
                                },
                                function(response) {
                                    throw (response.data);
                                });
                    };
                    this.addSocialEnvironment = function(newSocialEnviromentRequest) {
                        return $http.post('api/account/addSocialEnviroment', newSocialEnviromentRequest).then(
                            function(response) {
                                return response.data;
                            },
                            function(response) {
                                throw (response.data);
                            });
                    }
                    this.createCannyUser = function(accountId) {
                        return $http.post('api/account/' + accountId + '/createCannyUser').then(
                            function (response) {
                                return response.data;
                            },
                            function (response) {
                                throw (response.data);
                            });
                    }
                    this.getCannySsoToken = function(accountId) {
                        return $http.get('api/account/' + accountId + '/getCannySsoToken').then(
                            function (response) {
                                return response.data;
                            },
                            function (response) {
                                throw (response.data);
                            });
                    }
                }
            ]
        );
})();